import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/dev-updates.css';
import Bubble from '../components/Bubble';

const DevUpdates = () => {
  const { t } = useTranslation();
  
  return (
    <div className="dev-updates-page">
      <h1 className="dev-updates-title">{t('devupdates.page.title')}</h1>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '25px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 1: Introducción */}
          <Bubble 
            className="bubble-1"
            title={t('bubbles.devupdates.intro.title')}
            content={t('bubbles.devupdates.intro.content')}
            translationKey="bubbles.devupdates.intro"
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 2: Últimas Actualizaciones */}
          <Bubble 
            className="bubble-2"
            title={t('bubbles.devupdates.latest.title')}
            content={t('bubbles.devupdates.latest.content')}
            translationKey="bubbles.devupdates.latest"            
            date={t('bubbles.devupdates.latest.date')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Segunda fila: Burbujas 3 y 4 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 3: Próximos Eventos */}
          <Bubble 
            className="bubble-3"
            title={t('bubbles.devupdates.events.title')}
            content={t('bubbles.devupdates.events.content')}
            translationKey="bubbles.devupdates.events"
            date={t('bubbles.devupdates.events.date')}
            color="orange"
            position="center"
            size="medium"
          />

          {/* Burbuja 4: Actualización Técnica */}
          <Bubble 
            className="bubble-4"
            title={t('bubbles.devupdates.technical.title')}
            content={t('bubbles.devupdates.technical.content')}
            translationKey="bubbles.devupdates.technical"
            date={t('bubbles.devupdates.technical.date')}
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Tercera fila: Burbujas 5 y 6 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 5: Anuncio de Asociación Estratégica */}
          <Bubble 
            className="bubble-5"
            title={t('bubbles.devupdates.partnership.title')}
            content={t('bubbles.devupdates.partnership.content')}
            translationKey="bubbles.devupdates.partnership"
            date={t('bubbles.devupdates.partnership.date')}
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 6: Actualizaciones Anteriores */}
          <Bubble 
            className="bubble-6"
            title={t('bubbles.devupdates.previous.title')}
            content={t('bubbles.devupdates.previous.content1') + "\n\n" + t('bubbles.devupdates.previous.content2')}
            color="green"
            position="center"
            size="medium"
          />
        </div>
      </div>
    </div>
  );
};

export default DevUpdates;
